import { useEffect, useState } from 'react';
import { watchpatSleepRecorderTypes } from '@common/validation/customControls/somnology';
import { RequestReadButtons } from '@frontend/components/elements/carePathButtons';
import { SleepRecorderDetails } from '@frontend/components/elements/SleepRecorderDetails';
import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { getServiceLabel } from '../../../../../../common/customControls/getServiceLabel';
import { SomnologyOrganizationType } from '../../../../../../common/enums/somnologyOrganizationType';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { ProcessContainer } from '../../../episodes/common';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';

export function OsasvoV1RequestRead(props: ICustomControlRequestReadProps) {
    const [hideButtons, setHideButtons] = useState(false);

    useEffect(() => {
        if (
            props.request.customControlData &&
            props.request.customControlData.somnologyOrganizationType ===
                SomnologyOrganizationType.ksyosMedicalCenter &&
            !watchpatSleepRecorderTypes.includes(props.request.customControlData.typeSlaaprecorder)
        ) {
            setHideButtons(true);
        }
        props.setHideCreateActions(true);
    }, []);

    return (
        <ProcessContainer>
            <ProcessItemHeader
                date={props.process.dateSent || (props.request && props.request.dateSent)}
                isFirstItem={props.isFirstItem}
                isFirstProcess={props.itemState.isFirstProcess}
                isItemOpen={props.itemState.isOpen}
                onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                organizationName={props.process.requesterOrganization?.name}
                practitionerName={
                    props.process.requesterPractitioner
                        ? getDisplayName(props.process.requesterPractitioner)
                        : undefined
                }
                process={props.process}
                serviceType={props.process.serviceType}
                title={getServiceLabel(props.process.code, 'request', props.process.name)}
            />

            <SleepRecorderDetails
                distributionMethod={props.request.customControlData.slaaprecorderVerzenden}
                patientHasSmartphone={props.request.customControlData.patientHasSmartphone}
                sleepRecorderType={props.request.customControlData.typeSlaaprecorder}
            />

            {!hideButtons && <RequestReadButtons {...props} />}
        </ProcessContainer>
    );
}
